import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import Svg from 'react-inlinesvg';

const Image = ({source, alt, imgClass, loading}) => {
  if(!source) {
    return (
      <div className={`image-missing${imgClass ? ' ' + imgClass : ''}`}></div>
    )
  }

  if(
    source.mimeType &&
    source.mimeType === 'image/svg+xml' &&
    source.localFile.publicURL
  ) {
    return (
      <Svg src={source.localFile.publicURL} title={source.altText} />
    )
  }

  if(source.localFile?.childCloudinaryAsset?.gatsbyImageData || source.gatsbyImageData) {
    return (
      <GatsbyImage
        image={source.localFile?.childCloudinaryAsset?.gatsbyImageData || source.gatsbyImageData}
        alt={source.altText ? source.altText : ''}
        className={imgClass}
        loading={loading}
      />
    )
  }

  if(source.original_src || source.src) {
    return (
      <img
        src={source.original_src || source.src}
        alt={source.alt || ""}
        className={imgClass}
      />
    )
  }

  return (
    <img src={source} className={imgClass} alt={alt} />
  );
}

export default Image;
